import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 获取民族列表
  static getNationList(params) {
    return request({
      url: `basic/nation/list`,
      host: config.HOST_MALL,
      params
    });
  }

  // 获取银行总行列表
  static getHeadBankList() {
    return request({
      url: `basic/bank/query/enable/headBank`,
      host: config.HOST_MALL
    });
  }

  /**
   * 查询会员信息
   */
  static queryLoseInfo(cardCode) {
    return request({
      url: `user/upgrade/queryUpgradeCompletionInfor/${cardCode}?cardCodeParam=${cardCode}`,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }

  static queryUserIdByCardCode(cardCode) {
    return request({
      url: `user/info/getUserId?cardCode=${cardCode}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 查询证件类型列表
   */
  static queryIdCardTypeList(cardCode) {
    return request({
      url: `user/info/queryIdentityTypeInfo?cardCode=${cardCode}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 保存审核记录
   */

  static examineAdd(params) {
    return new Promise((resolve, reject) => {
      request({
        url: 'certificate/examine/add',
        host: config.HOST_MALL,
        data: params,
        method: 'post_json'
      }).then((e) => {
        if (e.data) {
          if (params.flag == 1) {
            // 走老流程
            if (e.data.status == 1) {
              resolve(e.data);
            } else {
              reject(e.data.msg);
            }
          } else {
            // 走新流程
            if (e.data.status == 1 || e.data.status == 3) {
              resolve(e.data);
            } else {
              reject(e.data.msg);
            }
          }
        } else {
          reject(e.resultMsg);
        }
      });
    });
  }

  /**
   * 保存会员信息
   */
  static saveUserInfo(params) {
    return request({
      url: `user/upgrade/UpdateUpgradeCompletionInfor`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 保存会员信息
   */
  static saveAccoumulateUserInfo(params, remindTag) {
    // const status =5
    const status = remindTag || 5;
    return request({
      url: `user/info/accumulateUserInfo/${status}`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
  /**
   * 检验卡号是否有效
   */
  static verifyMemberCardValid(params) {
    return request({
      url: 'store/create/checkMemberCardValid',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取工作室类型列表
   */
  static getStoreTypeList(params) {
    return request({
      url: `store_type/list`,
      host: config.HOST_STORE,
      params
    });
  }

  /**
   * 获取体系区域配置情况
   */
  static getRegionConfiguration(params) {
    return request({
      url: `store_type/validate/occupancy`,
      host: config.HOST_STORE,
      params,
      method: 'post'
    });
  }

  /**
   * 创建订单
   */
  static addOrder(url, params) {
    return request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * @description 根据卡号获取健康顾问的卡号和信息
   */
  static getUserInfoByCardCode(params) {
    return request({
      url: 'user/info/relationInfo',
      host: config.HOST_MALL,
      params
    });
  }

  static setContractSign(params) {
    return request({
      url: `user/contract/sign`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查找代客，客对应的订单类型名称
   */
  static queryOrderTypeInfo(params) {
    return request({
      url: 'basic/orderType/byCardCode',
      host: config.HOST_MALL,
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/MsgAdd/MsgAddServ.js